import { BackEndCodeLanguage, BackEndCodeLanguageType } from '@prophecy/graphql-types/enums';
import { Select } from '@prophecy/ui-v3';
import React, { useMemo } from 'react';
import styled from 'styled-components';

import { TeamsType } from '../config/queries';
import { useProjectTeamsQuery } from '../useProjectTeamsQuery';

const StyledSelect = styled(Select)`
  width: 200px;
`;
export const TeamsProjects = ({
  disabled,
  hasLabel = true,
  onChange,
  hasLanguageFilter = true,
  value,
  language = BackEndCodeLanguage.scala,
  footer
}: {
  disabled?: boolean;
  value: string;
  hasLanguageFilter?: boolean;
  hasLabel?: boolean;
  onChange: (value: string, teams: TeamsType[]) => void;
  language?: BackEndCodeLanguageType;
  isNameSelection?: boolean;
  footer?: React.ReactNode;
}) => {
  const { data, isLoading, isError } = useProjectTeamsQuery();
  const teamOptions = useMemo(() => {
    const teams = data?.User?.teams || [];
    return hasLanguageFilter
      ? teams.filter(
          (team) => team.projects.length > 0 && team.projects.some((project) => project.language === language)
        )
      : teams;
  }, [data?.User?.teams, language, hasLanguageFilter]);

  return (
    <StyledSelect
      showSearch={true}
      label={hasLabel ? 'Project*' : ''}
      disabled={isError || isLoading || disabled}
      value={value === '' ? 'Select Project' : value}
      footer={footer}
      data-test-id='transpiler-teams-projects-select'
      onChange={(name) => onChange(name, teamOptions)}>
      {teamOptions.map((team) => {
        const projects =
          (hasLanguageFilter ? team?.projects?.filter((project) => project.language === language) : team.projects) ||
          [];
        return (
          <Select.OptGroup label={team.name} key={team._id}>
            {projects.map((project) => (
              <Select.Option key={project._id} value={project._id}>
                {project.name}
              </Select.Option>
            ))}
          </Select.OptGroup>
        );
      })}
    </StyledSelect>
  );
};
